var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "shop_brands_config",
      attrs: {
        model: _vm.value.config,
        disabled: _vm.disabled,
        rules: _vm.rules,
      },
    },
    [
      _c(
        "el-form-item",
        { attrs: { prop: "name" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("组件名称")]),
          _c("el-input", {
            attrs: { placeholder: "输入10个字以内的名称", clearable: "" },
            model: {
              value: _vm.value.config.name,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "name", $$v)
              },
              expression: "value.config.name",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { prop: "category_id" } },
        [
          _c("div", { staticClass: "label" }, [_vm._v("选择实体菜单")]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: { filterable: "", placeholder: "选择实体菜单" },
              on: { change: _vm.changeCategory },
              model: {
                value: _vm.value.config.category_id,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "category_id", $$v)
                },
                expression: "value.config.category_id",
              },
            },
            _vm._l(_vm.menuListFilter, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  label: item.show_name,
                  value: item.id,
                  disabled: item.disabled,
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "brandName" },
        [
          _c("div", { staticClass: "label" }, [_vm._v("设置组件封面展示品牌")]),
          _c("div", { staticClass: "tips" }, [
            _vm._v("已添加的封面品牌拖动可排序，点击右上方按钮删除"),
          ]),
          _c(
            "el-select",
            {
              staticStyle: { width: "100%" },
              attrs: {
                placeholder: "搜索或选择品牌",
                clearable: "",
                filterable: "",
                disabled: !_vm.value.config.category_id,
              },
              model: {
                value: _vm.bid,
                callback: function ($$v) {
                  _vm.bid = $$v
                },
                expression: "bid",
              },
            },
            _vm._l(_vm.list, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: {
                  label: item.brand_name,
                  value: item.id,
                  disabled: _vm.value.config.bids.includes(item.id),
                },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.addBrand } },
            [_vm._v("添加到组件封面品牌")]
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        { staticClass: "brandList", attrs: { prop: "brandList" } },
        [
          _c(
            "draggable",
            {
              attrs: { animation: "500", "force-fallback": true },
              model: {
                value: _vm.value.config.brandList,
                callback: function ($$v) {
                  _vm.$set(_vm.value.config, "brandList", $$v)
                },
                expression: "value.config.brandList",
              },
            },
            _vm._l(_vm.value.config.brandList, function (item, index) {
              return _c("div", { key: item.id, staticClass: "brand" }, [
                _c("div", { staticClass: "name" }, [
                  _vm._v(" " + _vm._s(item.brand_name) + " "),
                ]),
                _c("i", {
                  staticClass: "el-icon el-icon-close",
                  on: {
                    click: function ($event) {
                      return _vm.deleteBrand(index)
                    },
                  },
                }),
              ])
            }),
            0
          ),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "margin_top",
          attrs: {
            prop: "margin_top",
            rules: [{ type: "number", message: "间距必须为数字值" }],
          },
        },
        [
          _c("div", [_vm._v(" 与上方组件的间距 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入间距", clearable: "" },
            model: {
              value: _vm.value.config.margin_top,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "margin_top", _vm._n($$v))
              },
              expression: "value.config.margin_top",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        {
          staticClass: "z_index",
          attrs: {
            prop: "z_index",
            rules: [
              {
                required: true,
                pattern: /^(?:[1-9]|[1-9][0-9])$/,
                message: "请输入1-99之间的整数！",
              },
            ],
          },
        },
        [
          _c("div", [_vm._v(" 层级高度值 ")]),
          _c("el-input", {
            attrs: { placeholder: "请输入层级高度值", clearable: "" },
            model: {
              value: _vm.value.config.z_index,
              callback: function ($$v) {
                _vm.$set(_vm.value.config, "z_index", _vm._n($$v))
              },
              expression: "value.config.z_index",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }